import React from 'react';
import { Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import { ModalFooter } from '~/components/Modal';
import { RedTimes, TableView } from '~/stylizations/styles';
import Strong from '~/components/Strong';

export default function PatrimonyView({ visible, onClose, patrimony, isMobile }) {
  const { t } = useTranslation();

  const label = (text) => <span style={{ fontSize: '18px', fontWeight: 'bold' }}>{t(text)}</span>;
  const child = (text) => {
    if (text == null || text == '') {
      return <RedTimes />;
    }

    return <span style={{ fontSize: '15px', fontWeight: 'bold' }}>{t(text)}</span>;
  };

  const childMobile = [
    {
      title: label('Pagamentos'),
      dataIndex: 'summary',
      key: 'summary',
      render: (text, record) => (
        <div>
          <Strong>{t('screens:Descrição')}:</Strong> {record.description}
          <br />
          <Strong>{t('screens:Data de Aquisição')}:</Strong> {record.acquired_at}
          <br />
          <Strong>{t('screens:Preço')}:</Strong> {record.price}
          <br />
        </div>
      ),
    },
  ];

  return (
    <Modal
      title={`${t('Informações')} - ${patrimony?.name ?? ''}`}
      open={visible}
      onCancel={onClose}
      centered
      width={isMobile ? '100%' : '1200px'}
      footer={<ModalFooter showOk={false} onCancel={onClose} />}
    >
      <TableView
        pagination={false}
        rowKey={() => 'basic-1'}
        bordered
        columns={[{ title: label('Nome'), dataIndex: 'name', render: child }]}
        dataSource={[patrimony] || []}
      />
      <TableView
        pagination={false}
        rowKey={() => 'basic-1'}
        bordered
        columns={
          isMobile
            ? childMobile
            : [
                { title: label('Descrição'), dataIndex: 'description', render: child },
                { title: label('Data de Aquisição'), dataIndex: 'acquired_at', render: child },
                { title: label('Preço'), dataIndex: 'price', render: child },
              ]
        }
        dataSource={patrimony?.patrimony_payments}
      />
    </Modal>
  );
}
